import App,{PDFViewer,
  forceFileDownload,
  Preview,
  Deformation,
  PageTurning,
  PrevAndNext,
  Print,
  Rotate,
  BackButton,
  Reset,}  from "./App.page"
  export default App;
  export {
    PDFViewer,
    forceFileDownload,
    Preview,
    Deformation,
    PageTurning,
    PrevAndNext,
    Print,
    Rotate,
    BackButton,
    Reset,
  };